export default __webpack_public_path__ + "static/media/celebration.40f23632.gif";